/**
 * @file paddle hub 首页 store
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useMenuList} from '../../components/model-base-menu/modelBaseMenuHooks';
import {MODEL_BASE_MENU_HOT} from '../../components/model-base-menu/constants';


const getDefaultActiveKeys = (): string[] => {
    const urlSearch = new URLSearchParams(window.location.search.slice(1));
    const categoryId = urlSearch.get('categoryId');
    if (categoryId) {
        return [categoryId];
    }
    return [MODEL_BASE_MENU_HOT.id];
};

function useModelBaseHooks() {
    const {
        menuList,
        menuActiveKeys,
        menuOpenKeys,
        modelList,

        onMenuActiveChange,
        onMenuOpenChange
    } = useMenuList({
        menuActiveKeys: getDefaultActiveKeys()
    });

    return {
        menuList,
        menuActiveKeys,
        menuOpenKeys,
        modelList,

        onMenuActiveChange,
        onMenuOpenChange
    };
}

export default useModelBaseHooks;
